// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const { setInitialised, addWheelControls, useArrows } =
  window.BAO.Carousel.plugins
class ProductCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) return
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    let hasInteractedWith = false
    const event = new Event('productCarousel:interacted')

    this.addEventListener(
      'productCarousel:interacted',
      () => {
        this.els.previous.element.classList.add('btn-CarouselButton-visible')
      },
      false,
    )

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: 2,
          spacing: 10,
        },
        breakpoints: {
          '(max-width: 767px)': {
            slides: {
              perView: 2,
              spacing: 10,
            },
          },
          '(min-width: 768px)': {
            slides: {
              perView: 3,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4,
              spacing: 30,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        (slider) => {
          slider.on('slideChanged', () => {
            if (hasInteractedWith) {
              this.removeEventListener(
                'productCarousel:interacted',
                this.setupCarousel,
                true,
              )
              return
            }

            this.dispatchEvent(event)

            hasInteractedWith = true
          })
        },
        useArrows({
          previous: this.els.previous.element,
          next: this.els.next.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
